import React from "react";
import { AudioChoice, HomeMasjid, partnerStartsItself } from "./homeSettings";

interface AudioChoicePickerProps {
  masjid: HomeMasjid;
  // Only the home masjid may play by itself.
  isHome: boolean;
  value?: AudioChoice;
  onChange: (choice: AudioChoice) => void;
}

const AudioChoicePicker: React.FC<AudioChoicePickerProps> = ({ masjid, isHome, value, onChange }) => {
  const ownStream = masjid.audio === "masjid247";
  const partnerAuto = partnerStartsItself(masjid.audio);
  const options: { choice: AudioChoice; title: string; detail: string }[] = [
    ...((ownStream || partnerAuto) && isHome
      ? [
          {
            choice: "auto" as const,
            title: "Play it automatically",
            detail: ownStream
              ? "The broadcast starts on its own, then stops when it ends."
              : "Their player opens and starts on its own, then closes when the broadcast ends.",
          },
        ]
      : []),
    {
      choice: "ask",
      title: "Show a Listen button",
      detail: ownStream || partnerAuto
        ? "A message appears with a button to start listening."
        : "A message appears; tap it to open the masjid's own player.",
    },
    { choice: "off", title: "Do nothing", detail: "No message and no sound." },
  ];
  const selected = value ?? "ask";

  return (
    <div className="hs-choices" role="radiogroup" aria-label={`When ${masjid.name} goes live`}>
      {options.map((option) => (
        <button
          key={option.choice}
          role="radio"
          aria-checked={selected === option.choice}
          className={`hs-choice${selected === option.choice ? " active" : ""}`}
          onClick={() => onChange(option.choice)}
        >
          <strong>{option.title}</strong>
          <span>{option.detail}</span>
        </button>
      ))}
      {!ownStream && !partnerAuto && (
        <p className="hs-note">
          {masjid.name} streams through a partner service, so it can't start by itself.
        </p>
      )}
    </div>
  );
};

export default AudioChoicePicker;
